import React, { useEffect, useState } from "react";
import IconBar from "../Partials/IconBar";
import dictJson from "../../langCSV.json";
import Latex from "react-latex-next";
import { useHistory } from "react-router";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";

export default function Dictionary(props) {
  //Declarations
  const history = useHistory();

  if (
    props === undefined ||
    props.location === undefined ||
    props.location.state === undefined ||
    props.location.state.user === undefined
  )
    history.push("/login");

  const [user] = useState(props.location.state.user);
  const [selectedOption, setSelectedOption] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  let listToDisplay = dictJson;

  //use effect
  useEffect(() => {
    const searchRen = async () => {};
    searchRen();
  });

  //select langauge function
  //function triggers an onchange event which saves the targe*d option
  //saves to the useState
  const SelectFunction = () => {
    return (
      <>
        <Typography
          variant="h6"
          style={{
            fontWeight: "bold",
            color: "#fbcd02",
            padding: "5px",
            textAlign: "left",
            marginBottom: "5px",
            fontSize: "1.1rem",
          }}
        >
          Dictionary
        </Typography>

        <hr
          style={{
            marginBottom: "20px",
            borderColor: "#FBCD02",
            borderWidth: "1px",
            borderStyle: "solid",
            width: "100%",
          }}
        />
        <FormControl
          fullWidth
          variant="outlined"
          style={{ marginBottom: "10px" }}
        >
          <InputLabel
            id="language-select-label"
            sx={{
              color: "#FBCD02",
              "&.Mui-focused": {
                color: "#FBCD02",
              },
            }}
          >
            Language
          </InputLabel>
          <Select
            labelId="language-select-label"
            id="language-select"
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
            label="Language"
            sx={{
              backgroundColor: "#00122d",
              color: "white",
              "& .MuiSvgIcon-root": {
                color: "white",
              },
              textAlign: "left",
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#FBCD02",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#00122d",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#FBCD02",
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  textAlign: "left",
                  backgroundColor: "#00122d",
                  color: "white",
                },
              },
              MenuListProps: {
                sx: {
                  "& .Mui-selected": {
                    backgroundColor: "#FBCD02 !important",
                    color: "#00122d",
                  },
                },
              },
            }}
          >
            <MenuItem value={"English"}>English</MenuItem>
            <MenuItem value={"Afrikaans"}>Afrikaans</MenuItem>
            <MenuItem value={"Sepedi"}>Sepedi</MenuItem>
            <MenuItem value={"Sesotho"}>Sesotho</MenuItem>
            <MenuItem value={"Setswana"}>Setswana</MenuItem>
            <MenuItem value={"Tshivenda"}>Tshivenda</MenuItem>
            <MenuItem value={"isiXhosa"}>isiXhosa</MenuItem>
            <MenuItem value={"isiZulu"}>isiZulu</MenuItem>
          </Select>
        </FormControl>
      </>
    );
  };

  //handler that sets state from input box
  //this function is trigger by an onchange event in search input box
  const handleChange = (e) => {
    setSearchTerm(e.target.value.toString().toLowerCase());
  };

  //search function
  //reassign the normal render list variable to
  //the json file filter, so when the user types, this will pick it up, and filter the orginal json by the search term
  //return the items and re-assign the variable then display.
  listToDisplay = dictJson.filter((item) => {
    return item.word.includes(searchTerm);
  });

  let handleImageError = (e) => {
    e.target.style.display = "none";
  };

  //This function is in charge of rendering the list, regardless if its filtered or not
  const renderDictList = () => {
    //default language print
    if (selectedOption == "") {
      return listToDisplay.map((item, i) => {
        let wordWithoutSpaces = item.word.replaceAll(" ", "_");
        wordWithoutSpaces = wordWithoutSpaces.replaceAll("&", "_");
        let picture = "/screenGrabs/d-" + wordWithoutSpaces + ".PNG";

        return (
          <div
            key={i}
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "5px",
              margin: "10px 0",
              paddingTop: "10px",
            }}
          >
            <div style={{ fontWeight: "bold", color: "#00112e" }}>
              {item.word.charAt(0).toUpperCase() + item.word.slice(1)}:
            </div>
            <div style={{ padding: "10px 20px" }}>
              <Latex>{item.english_des}</Latex>
            </div>

            <div style={{ overflow: "hidden", padding: "10px 0px" }}>
              <img src={picture} onError={(event) => handleImageError(event)} />
            </div>
            <div>
              <p></p>
            </div>
          </div>
        );
      });
    }
    //english option print
    if (selectedOption == "English") {
      return listToDisplay.map((item, i) => {
        let wordWithoutSpaces = item.word.replaceAll(" ", "_");
        wordWithoutSpaces = wordWithoutSpaces.replaceAll("&", "_");
        let picture = "/screenGrabs/d-" + wordWithoutSpaces + ".PNG";

        return (
          <div
            key={i}
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "3px",
              margin: "10px 0",
            }}
          >
            <div>{item.word}:</div>
            <div style={{ padding: "10px 20px" }}>
              <Latex>{item.english_des}</Latex>
            </div>
            <div style={{ overflow: "hidden", padding: "10px 0px" }}>
              <img src={picture} onError={(event) => handleImageError(event)} />
            </div>
            <div>
              <p></p>
            </div>
          </div>
        );
      });
    }
    //afrikaans option print
    if (selectedOption == "Afrikaans") {
      return listToDisplay.map((item, i) => {
        let wordWithoutSpaces = item.word.replaceAll(" ", "_");
        wordWithoutSpaces = wordWithoutSpaces.replaceAll("&", "_");
        let picture = "/screenGrabs/d-" + wordWithoutSpaces + ".PNG";

        return (
          <div
            key={i}
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "3px",
              margin: "10px 0",
            }}
          >
            <div>{item.word}:</div>
            <div style={{ padding: "10px 20px" }}>
              <Latex>{item.afrikaans_des}</Latex>
            </div>
            <div style={{ overflow: "hidden", padding: "10px 0px" }}>
              <img src={picture} onError={(event) => handleImageError(event)} />
            </div>
            <div>
              <p></p>
            </div>
          </div>
        );
      });
    }
    if (selectedOption == "Sepedi") {
      return listToDisplay.map((item, i) => {
        let wordWithoutSpaces = item.word.replaceAll(" ", "_");
        wordWithoutSpaces = wordWithoutSpaces.replaceAll("&", "_");
        let picture = "/screenGrabs/d-" + wordWithoutSpaces + ".PNG";

        return (
          <div
            key={i}
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "3px",
              margin: "10px 0",
            }}
          >
            <div>{item.word}:</div>
            <div style={{ padding: "10px 20px" }}>
              <Latex>{item.sepedi_des}</Latex>
            </div>
            <div style={{ overflow: "hidden", padding: "10px 0px" }}>
              <img src={picture} onError={(event) => handleImageError(event)} />
            </div>
            <div>
              <p></p>
            </div>
          </div>
        );
      });
    }
    if (selectedOption == "Sesotho") {
      return listToDisplay.map((item, i) => {
        let wordWithoutSpaces = item.word.replaceAll(" ", "_");
        wordWithoutSpaces = wordWithoutSpaces.replaceAll("&", "_");
        let picture = "/screenGrabs/d-" + wordWithoutSpaces + ".PNG";

        return (
          <div
            key={i}
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "3px",
              margin: "10px 0",
            }}
          >
            <div>{item.word}:</div>
            <div style={{ padding: "10px 20px" }}>
              <Latex>{item.sesotho_des}</Latex>
            </div>
            <div style={{ overflow: "hidden", padding: "10px 0px" }}>
              <img src={picture} onError={(event) => handleImageError(event)} />
            </div>
            <div>
              <p></p>
            </div>
          </div>
        );
      });
    }
    //Tswana option print
    if (selectedOption == "Setswana") {
      return listToDisplay.map((item, i) => {
        let wordWithoutSpaces = item.word.replaceAll(" ", "_");
        wordWithoutSpaces = wordWithoutSpaces.replaceAll("&", "_");
        let picture = "/screenGrabs/d-" + wordWithoutSpaces + ".PNG";

        return (
          <div
            key={i}
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "3px",
              margin: "10px 0",
            }}
          >
            <div>{item.word}:</div>
            <div style={{ padding: "10px 20px" }}>
              <Latex>{item.setwana_des}</Latex>
            </div>
            <div style={{ overflow: "hidden", padding: "10px 0px" }}>
              <img src={picture} onError={(event) => handleImageError(event)} />
            </div>
            <div>
              <p></p>
            </div>
          </div>
        );
      });
    }
    //venda option print
    if (selectedOption == "Tshivenda") {
      return listToDisplay.map((item, i) => {
        let wordWithoutSpaces = item.word.replaceAll(" ", "_");
        wordWithoutSpaces = wordWithoutSpaces.replaceAll("&", "_");
        let picture = "/screenGrabs/d-" + wordWithoutSpaces + ".PNG";

        return (
          <div
            key={i}
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "3px",
              margin: "10px 0",
            }}
          >
            <div>{item.word}:</div>
            <div style={{ padding: "10px 20px" }}>
              <Latex>{item.tshivenda_des}</Latex>
            </div>
            <div style={{ overflow: "hidden", padding: "10px 0px" }}>
              <img src={picture} onError={(event) => handleImageError(event)} />
            </div>
            <div>
              <p></p>
            </div>
          </div>
        );
      });
    }
    //xhosa option print
    if (selectedOption == "isiXhosa") {
      return listToDisplay.map((item, i) => {
        let wordWithoutSpaces = item.word.replaceAll(" ", "_");
        wordWithoutSpaces = wordWithoutSpaces.replaceAll("&", "_");
        let picture = "/screenGrabs/d-" + wordWithoutSpaces + ".PNG";

        return (
          <div
            key={i}
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "3px",
              margin: "10px 0",
            }}
          >
            <div>{item.word}:</div>
            <div style={{ padding: "10px 20px" }}>
              <Latex>{item.xhosa_des}</Latex>
            </div>
            <div style={{ overflow: "hidden", padding: "10px 0px" }}>
              <img src={picture} onError={(event) => handleImageError(event)} />
            </div>
            <div>
              <p></p>
            </div>
          </div>
        );
      });
    }
    //zulu option print
    if (selectedOption == "isiZulu") {
      return listToDisplay.map((item, i) => {
        let wordWithoutSpaces = item.word.replaceAll(" ", "_");
        wordWithoutSpaces = wordWithoutSpaces.replaceAll("&", "_");
        let picture = "/screenGrabs/d-" + wordWithoutSpaces + ".PNG";

        return (
          <div
            key={i}
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "3px",
              margin: "10px 0",
            }}
          >
            <div>{item.word}:</div>
            <div style={{ padding: "10px 20px" }}>
              <Latex>{item.zulu_des}</Latex>
            </div>
            <div style={{ overflow: "hidden", padding: "10px 0px" }}>
              <img src={picture} onError={(event) => handleImageError(event)} />
            </div>
            <div>
              <p></p>
            </div>
          </div>
        );
      });
    }
  };

  //returning
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: windowWidth >= 800 ? "50%" : "90%",
        borderRadius: "5px",
      }}
    >
      {/*nav bar container*/}
      <div
        style={{
          backgroundColor: "#00112e",
          position: "sticky",
          top: 0,
          zIndex: 1,
          paddingTop: "10px",
        }}
      >
        {/*icon bar */}
        <div
          style={{
            backgroundColor: "#00112e",
            display: "flex",
            padding: "20px 0px",
          }}
        >
            <IconBar location="dictionary" user={user} />
        </div>

        {/*search function*/}

        <div
          style={{
            backgroundColor: "#212a41",
            padding: "15px",
            borderRadius: "5px",
            marginBottom: "20px",
          }}
        >
          <SelectFunction />

          <div>
            {/* Search function */}
            <TextField
              label="Search"
              id="outlined-basic"
              variant="outlined"
              // placeholder="Search"
              value={searchTerm}
              onChange={handleChange}
              fullWidth
              sx={{
                backgroundColor: "#00122d",
                borderRadius: "5px",
                width: "100%",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#00122d",
                  },
                  "&:hover fieldset": {
                    borderColor: "#FBCD02",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#FBCD02",
                  },
                },
              }}
              InputLabelProps={{
                style: { color: "#FBCD02" },
              }}
              inputProps={{
                style: { color: "white" },
              }}
            />
          </div>
          {/* <input type="text" placeholder='Search' value={searchTerm} onChange={handleChange} /> */}
        </div>
      </div>

      {/*container*/}
      <div
        style={{
          backgroundColor: "#212a41",
          paddingLeft: "15px",
          paddingRight: "15px",
          paddingTop: "15px",
          borderRadius: "5px",
        }}
      >
        {/*content container*/}
        <div style={{ backgroundColor: "#212a41", height: "100%" }}>
          {/*{regularPrint()}*/}
          {renderDictList()}
        </div>
      </div>
    </div>
  );
}
